import { useContext, createContext, useState, useEffect } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const RoleContext = createContext()

const RoleProvider = ({ children }) => {
    const { headers } = useAuth();

    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        if (roleList.length === 0 && headers.Authorization !== '') {
            getAllRoles();
        }
    }, [roleList, headers])

    //Get All Roles
    const getAllRoles = async () => {
        try {
            const { data } = await axios.get(`${baseURL}/role/list`, { headers })
            if (data.error === false) {
                if (data.data.length > 0) {
                    setRoleList(data.data)
                }
                return data.data
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <RoleContext.Provider value={{ getAllRoles, roleList }}>
            {children}
        </RoleContext.Provider>
    )
}

const useRole = () => useContext(RoleContext)

export { useRole, RoleProvider }